<script setup>
defineProps({
	shipmentType: Object,
	originAddress: String,
	destinationAddress: String,
	storageAddress: String,
	storagePeriod: String,
	reference: String,
	transportDate: String,
	warehouseDate: String,
	statusClass: String,
	title: String,
	storagePolicies: Array,
	shipName: String,
});
</script>

<template>
	<div class="shipment" :class="[statusClass]">
		<div class="shipment-view w-100">
			<div class="shipment-header">
				<div class="row align-items-center g-0">
					<div class="col">
						<div class="shipment-type" v-if="shipmentType">
							<i :class="shipmentType.icon"></i>
							<span v-if="title">
								<small>Policy: {{ title }}</small>
							</span>
							<span v-else>
								<small>{{ shipmentType.label }}</small>
							</span>
						</div>
					</div>

					<slot name="header-buttons"></slot>
				</div>
			</div>

			<div class="shipment-body">
				<div class="row justify-content-end g-0">
					<!-- Origin -->
					<div class="col-12 col-lg-6" v-if="originAddress">
						<div class="shipment-field origin shipment-origin">
							<label><small>Origin</small></label>
							<div>
								{{ originAddress }}
							</div>
						</div>
					</div>

					<!-- Destination -->
					<div class="col-12 col-lg-6" v-if="destinationAddress">
						<div class="shipment-field destination shipment-destination">
							<label><small>Destination</small></label>
							<div>
								{{ destinationAddress }}
							</div>
						</div>
					</div>

					<!-- Ship name -->
					<div class="col-12 col-lg-6" v-if="shipmentType.value === 'sea'">
						<div class="shipment-field">
							<label><small>Name of ship</small></label>
							<div>{{ shipName }}</div>
						</div>
					</div>

					<!-- Storage location -->
					<div class="col-12 col-lg-6" v-if="storageAddress">
						<div class="shipment-field">
							<label><small>Storage location</small></label>
							<div>{{ storageAddress }}</div>
						</div>
					</div>

					<!-- Storage period -->
					<div class="col-12 col-lg-6" v-if="storagePeriod">
						<div class="shipment-field">
							<label><small>Storage period</small></label>
							<div>{{ storagePeriod }}</div>
						</div>
					</div>

					<!-- Reference -->
					<div class="col-12 col-lg-6" v-if="reference">
						<div class="shipment-field">
							<label><small>Reference</small></label>
							<div>{{ reference }}</div>
						</div>
					</div>

					<!-- Transport Date -->
					<div class="col-12 col-lg-6" v-if="transportDate">
						<div class="shipment-field">
							<label><small>Transport date</small></label>
							<div>
								{{ transportDate }}
							</div>
						</div>
					</div>

					<!-- Warehouse-in Date -->
					<div class="col-12 col-lg-6" v-if="warehouseDate">
						<div class="shipment-field">
							<label><small>Warehouse-in date</small></label>
							<div>
								{{ warehouseDate }}
							</div>
						</div>
					</div>

					<!-- Warning slot (for sanction law, etc) -->
					<div
						v-if="$slots.warning"
						class="alert alert-warning d-flex align-items-center mx-3 gap-3"
					>
						<i class="ri-error-warning-line h4 mb-0"></i>
						<slot name="warning"></slot>
					</div>

					<div class="d-flex justify-content-between align-items-center mt-3">
						<slot name="footer-button-left"><div></div></slot>
						<slot name="footer-button-right"></slot>
					</div>
				</div>
			</div>
		</div>
	</div>

	<template
		v-for="(storagePolicy, index) in storagePolicies"
		:key="storagePolicy.id"
	>
		<!-- TODO: status class -->
		<expedition-tile
			:shipmentType="{ label: 'Storage', icon: 'ri-archive-fill' }"
			:storageAddress="storagePolicy.address?.address"
			:storagePeriod="storagePolicy.storagePeriod.label"
			:warehouseDate="
				new Date(storagePolicy.transportDate.date).toLocaleDateString('en-GB')
			"
			:title="storagePolicy.title"
		>
			<template v-slot:footer-button-left v-if="index === 0">
				<slot name="extend-storage" :storage-policy="storagePolicy"></slot>
			</template>
			<template v-slot:footer-button-right>
				<div class="specify-insurance">
					<a
						type="button"
						class="btn btn-rounded btn-blue btn-actions"
						:href="`/expeditions/policies/${storagePolicy.uid}`"
					>
						<span>View</span>
						<i class="ri-arrow-right-line"></i>
					</a>
				</div>
			</template>
		</expedition-tile>
	</template>
</template>

<style scoped>
.specify-insurance {
	padding: 10px;
}

.alert-warning {
	flex-shrink: 1;
}

.btn-actions {
	margin: 15px;
}
</style>
